import styled from 'styled-components'

import Flex from 'components/Flex'

export const Wrapper = styled(Flex)`
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  pointer-events: ${props => (props?.pointer ? 'none' : '')};
  opacity: ${props => (props?.opacity ? '0.5' : '')};
`
export const FleXWrapper = styled(Flex)`
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  gap: 20px;
  justify-content: 'space-between';
`
export const ContentFlex = styled(Flex)`
  gap: ${props => (props.gap ? props.gap : '8px')};
  width: ${props => (props.width ? props.width : '90%')};
`
export const IconWrapper = styled(Flex)`
  height: 60px;
  width: 50px;
  margin-top: 10px;
  background: #f2f3f5;
  border-radius: 10px;
  padding: ${props => (props?.padding ? '10px' : '14px')};
  margin-right: 10px;
  align-items: center;
  justify-content: center;
`

export const TextWrapper = styled(Flex)`
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  color: #010e30;
  padding-bottom: 3px;
`

export const SubTextWrapper = styled(Flex)`
  line-height: 20px;
  color: #999fac;
  letter-spacing: 0.1em;
  font-weight: bold;
  font-size: 12px;
  margin-top: 0.5em;
`

export const Icon = styled(Flex)`
  background: #f2f3f5;
  border-radius: 10px;
  padding: 7px;
  margin-left: 16px;
`
export const ActionWrap = styled(Flex)`
  gap: 5px;
  visibility: visible !important;
  text-align: right;
`

export const ResultWrapper = styled(Flex)`
  line-height: initial;
  align-items: center;
  gap: 3px;
`
export const StyledH2 = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  padding-top: 10px;
  margin-left: 9px;
`
export const Cirlcle = styled.div`
  padding: 4px;
  background: #4d566e;
  border-radius: 50% !important;
  margin-right: 9px;
`

export const StyledP = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #4d566e;
  padding-top: 5px;
  line-height: initial;
  width: 100%;
`

export const Minus = styled.div`
  display: flex;
  justify-content: center;
`
